var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.tab_available"),
        subtitle: _vm.$tc(
          "influencer_panel.available_count",
          _vm.campaigns.length,
          { count: _vm.campaigns.length }
        ),
      },
      scopedSlots: _vm._u(
        [
          _vm.modalities.length > 1
            ? {
                key: "actions",
                fn: function () {
                  return [
                    _c("b-form-select", {
                      staticClass: "available__filter",
                      attrs: { options: _vm.modalityOptions, size: "sm" },
                      model: {
                        value: _vm.modality,
                        callback: function ($$v) {
                          _vm.modality = $$v
                        },
                        expression: "modality",
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      !_vm.filtered.length
        ? _c("hb-empty-state", {
            attrs: {
              title: _vm.$t("influencer_panel.no_available"),
              icon: "SearchIcon",
            },
          })
        : _c(
            "div",
            { staticClass: "available__list" },
            _vm._l(_vm.filtered, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "available__row" },
                [
                  _c("div", { staticClass: "available__identity" }, [
                    _c("div", { staticClass: "available__name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("div", { staticClass: "available__entity" }, [
                      _vm._v(_vm._s(_vm.entityLine(item))),
                    ]),
                  ]),
                  _c("div", { staticClass: "available__stat" }, [
                    _c("div", { staticClass: "available__stat-label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.commission"))),
                    ]),
                    _c("div", { staticClass: "available__stat-value" }, [
                      _vm._v(_vm._s(_vm.campaignCommissionLabel(item))),
                    ]),
                  ]),
                  _vm.discountLabel(item)
                    ? _c("div", { staticClass: "available__stat" }, [
                        _c("div", { staticClass: "available__stat-label" }, [
                          _vm._v(_vm._s(_vm.$t("campaign.discount"))),
                        ]),
                        _c("div", { staticClass: "available__stat-value" }, [
                          _vm._v(_vm._s(_vm.discountLabel(item))),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "available__stat" }, [
                    _c("div", { staticClass: "available__stat-label" }, [
                      _vm._v(_vm._s(_vm.$t("campaign.products_count"))),
                    ]),
                    _c("div", { staticClass: "available__stat-value" }, [
                      _vm._v(_vm._s((item.products || []).length)),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "available__action" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("join", item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("influencer_panel.join")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }